import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const NoMobile90sWrapper = ({ children }: { children: React.ReactNode }) => {
  const [isMobile, setIsMobile] = useState(false)
  const [dismissed, setDismissed] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  if (isMobile && !dismissed) {
    return (
      <div className="mobile-overlay">
        <h1 className="mobile-title">🚫 {t('noMobile.title')}</h1>
        <p className="mobile-text">{t('noMobile.description')}</p>
        <button className="mobile-button" onClick={() => setDismissed(true)}>
          {t('noMobile.button')}
        </button>
      </div>
    )
  }

  return <>{children}</>
}

export default NoMobile90sWrapper
